import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import InstantMessageForm from '../../components/history/InstantMessageForm';
import { sendInstantMessage } from '../../../../data/followup/actions/followup';

class InstantMessageFormContainer extends Component {
    static propTypes = {
        sendInstantMessageSuccess: PropTypes.func,
        reset: PropTypes.func
    };

    handleSubmit(values) {
        return this.props.sendInstantMessage(values.message);
    }

    render() {
        return (
            <InstantMessageForm
                handleSubmit={::this.handleSubmit}
                enableReinitialize
                initialValues={{
                    message: ''
                }}
            />
        )
    }
}

export default connect(
    null,
    dispatch => bindActionCreators({ sendInstantMessage }, dispatch)
)(InstantMessageFormContainer);
